export const apiDomain =
  typeof window !== "undefined" && (window as any)?.apiDomain
    ? (window as any).apiDomain
    : "https://arhipov.kengurumi.ru";
